import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { TREATMENTS } from "../config/treatments";
import { WhatsAppCtaBanner } from "../components/WhatsAppCtaBanner";
import { SectionEyebrow } from "../components/SectionEyebrow";
import { buildLocalizedPath } from "../lib/langRoutes";

const TreatmentsListPage = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "de";
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-[#F6F5F2]">
      <section className="pt-36 lg:pt-44 pb-16 bg-[#F6F5F2]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <SectionEyebrow num="01">{t("treatments.eyebrow")}</SectionEyebrow>
          <h1 className="font-serif text-5xl lg:text-7xl font-light tracking-tight leading-[0.95] text-[#3E5239]">
            {t("treatments.title_l1")}
            <br />
            <span className="italic text-[#A7CA99]">{t("treatments.title_l2")}</span>
          </h1>
          <p className="mt-8 max-w-2xl text-base lg:text-lg font-light text-[#6B7A66] leading-relaxed">
            {t("treatments.intro")}
          </p>
        </div>
      </section>

      <section className="pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {TREATMENTS.map((tr) => {
            const item = t(`treatments.items.${tr.key}`, { returnObjects: true });
            return (
              <Link
                key={tr.key}
                to={buildLocalizedPath("treatmentDirect", lang, tr.slug)}
                data-testid={`treatment-list-${tr.key}`}
                className="group bg-[#F6F5F2] border border-[#E4E2DA] hover:border-[#A7CA99] transition-colors overflow-hidden block"
              >
                <div className="relative aspect-[16/9] overflow-hidden bg-[#EFEDE6]">
                  <img src={tr.hero} alt={item.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.05]" />
                  <div className="absolute top-4 right-4 px-3 py-1 bg-[#F6F5F2]/95 backdrop-blur-sm">
                    <span className="overline text-[#3E5239] text-[10px]">{item.price}</span>
                  </div>
                </div>
                <div className="p-8 lg:p-10">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#A7CA99]" />
                    <span className="text-[10px] uppercase tracking-[0.28em] font-semibold text-[#A7CA99]">
                      {item.subtitle}
                    </span>
                  </div>
                  <h2 className="font-serif text-3xl lg:text-4xl font-light text-[#3E5239]">{item.title}</h2>
                  <p className="mt-4 text-sm font-light text-[#6B7A66] leading-relaxed">{item.short_desc}</p>
                  <div className="mt-6 inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#3E5239] text-[#F6F5F2] text-[11px] uppercase tracking-[0.22em] font-medium group-hover:bg-[#A7CA99] group-hover:text-[#1F2D1D] transition-colors rounded-sm">
                    {t("common.learn_more")}
                    <span className="transition-transform group-hover:translate-x-1">→</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <WhatsAppCtaBanner source="treatments_list_bottom" />
    </div>
  );
};

export default TreatmentsListPage;
